<template>
  <div class="login fill-height">
    <x-form ref="loginForm" @submit.prevent="login">
        <div class="logo">
            <img
                src="/assets/img/tepfin-logo.svg"
                alt="TepfinX From Howden"
            >
        </div>


        <x-card>
            <h2>Welcome back</h2>

            <p>To log in, please click the button below. You will be redirected to our SSO page.</p>

            <p>Please have your phone accessible, as we may need to contact you to verify your identity.</p>

            <x-btn
                class="ma-0"
                color="primary"
                type="submit"
                small
                block
                :loading="loading"
            >
                Authenticate
            </x-btn>
        </x-card>

        <div class="message" v-if="loginError || loginInfo">
            <p v-if="loginError"class="error--text">
                {{ loginError }}
            </p>

            <p v-if="loginInfo" mt-2 class="info--text">
                {{ loginInfo }}
            </p>
        </div>

        <div class="legal">
            <a
                href="/assets/terms_and_conditions/Tepfin X - Terms and Conditions.docx"
                class="terms-link "
            >
                Terms and Conditions
            </a>

            <p class="copyright">
                Copyright © {{ year }} Howden Insurance Brokers ltd. <br>
                Registration 725875.
            </p>
        </div>
    </x-form>
  </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {
                loading: false
            }
        },
        computed: {
            loginError() {
                return this.$route.query.error;
            },
            loginInfo() {
                return this.$route.query.info;
            },
            year() {
                const year = new Date();

                return year.getFullYear();
            }
        },
        async created() {
            if (this.$hyperionAuth.isAuthenticated()) {
                this.loading = true;
                await this.$root.loadData();
                await this.$root.loadWaitingPeriods();

                if (['insurer', 'captive_insurer'].includes(this.$root.user.company.company_type)) {
                    this.$router.push('insurer/dashboard/');
                } else {
                    this.$router.push('agent/dashboard/');
                }
            }

        },
        methods: {
            login() {
                this.loading = true;
                this.$hyperionAuth.login();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .login {
        background-image: url("/assets/img/logo-bg.svg"),
                          radial-gradient(42.22% 83.5% at 26.53% 57.42%, rgba(224, 236, 137, 0.2) 0%, rgba(224, 236, 137, 0) 100%),
                          linear-gradient(116.55deg, #000000 0.39%, #173F35 100%);
        background-size: 100%;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-family: $font-body;

        a {
            color: white;
        }
    }

    .logo img {
        display: block;
    }

    .x-card {
        @include card-gradient;
        backdrop-filter: blur(10px);
        max-width: 394px;
        margin: 24px 0 32px;

        &::before {
            border-width: 2px;
        }

        h2 {
            font-size: rem(24px);
            margin-bottom: 16px;
        }

        p {
            color: $color-white;
            font-size: rem(14px);
            line-height: rem(20px);
            margin-bottom: 16px;

            &:last-child {
                margin-bottom: 32px;
            }
        }
    }

    .message {
        font-size: rem(14px);
        margin-bottom: 16px;
    }

    .legal {
        font-size: rem(11px);
        line-height: rem(16px);

        .terms-link {
            display: block;
            color: $color-teal;
            margin-bottom: 24px;
        }
    }

    form {
        display: flex;
        align-items: center;
        flex-direction: column;
    }
</style>
